<div class="input-group input-group-sm">
  <input
    class="form-control form-control-sm"
    type="text"
    [(ngModel)]="inputValue"
    [ngbTypeahead]="search"
    [resultFormatter]="formatter"
    (selectItem)="onSelect($event)"
    (blur)="onBlur()"
    placeholder="Digite para filtrar..."
    autocomplete="off"
    />
  @if (inputValue) {
    <div class="input-group-append">
      <button class="btn btn-outline-secondary btn-sm" type="button" (click)="onClear()">×</button>
    </div>
  }
</div>
